import * as React from "react";

export interface UnsavedChangesPromptProps {
  when: boolean;
  message?: string;
}

export function UnsavedChangesPrompt({
  when,
  message = "You have unsaved changes. Leave anyway?",
}: UnsavedChangesPromptProps) {
  React.useEffect(() => {
    if (!when) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [when, message]);

  return null;
}
